<template>
  <div class="columns content-wrapper">
    <div class="column" v-if="currentTerritoryId !== null && blocks !== null">
      <div class="content" v-for="(block, key) in blocks" :key="key">
        <h2 v-if="block.type === 'text' || block.type === 'image' || block.type === 'rich_text'">{{ block.title }}</h2>
        <div v-if="block.type === 'text' || block.type === 'rich_text'" v-html="block.content"></div>
        <img v-if="block.type === 'image'" :src="block.content" :alt="block.title" class="image">
        <div v-if="block.type === 'quiz'">
          <Quiz :id="block.quiz.id"></Quiz>
        </div>
        <div v-if="block.type === 'survey'">
          <Survey :id="block.survey.id"></Survey>
        </div>
        <div v-if="block.type === 'results'">
          <QuizResults></QuizResults>
        </div>
      </div>
    </div>
    <div class="column" v-else-if="currentTerritoryId !== null">
      <content-title :title="zone.name"></content-title>
      <article class="message is-danger">
        <div class="message-header">
          <p>There are no content blocks defined</p>
        </div>
        <div class="message-body">
          You need to define some content blocks for this zone in the backend application.
        </div>
      </article>
    </div>
    <div class="column" v-else>
      <article class="message is-primary">
        <div class="message-header">
          <p>Hi {{ nickname }}!</p>
        </div>
        <div class="message-body">
          Move closer to any of the exhibits or choose one from the left menu.
        </div>
      </article>
    </div>
  </div>
</template>

<script>
/**
 * Copyright (c) 2019. Filip Conka <filip@conka.pro>
 */
import { mapGetters } from 'vuex'
import ContentTitle from '../atoms/ContentTitle'
import mediumZoom from 'medium-zoom'
import Quiz from '../molecules/Quiz'
import Survey from '../molecules/Survey'
import QuizResults from '../molecules/QuizResults'

export default {
  name: 'Content',
  components: { QuizResults, Survey, Quiz, ContentTitle },
  computed: {
    ...mapGetters('territories', {
      territories: 'getTerritories',
      currentTerritoryId: 'getCurrentTerritoryId'
    }),
    ...mapGetters('tag', {
      nickname: 'getName'
    }),
    blocks: function () {
      const zones = this.territories

      if (zones === null || this.currentTerritoryId === null) { return null }

      if (zones[this.currentTerritoryId] === undefined || zones[this.currentTerritoryId].blocks === undefined) { return null }

      return zones[this.currentTerritoryId].blocks
    },
    zone: function () {
      const zones = this.territories

      if (zones === null || this.currentTerritoryId === null) { return null }

      if (zones[this.currentTerritoryId].name === undefined) { return null }

      return zones[this.currentTerritoryId]
    }
  },
  mounted () {
    mediumZoom('.image')
    mediumZoom('.content img')
  }
}
</script>

<style scoped lang="scss">
  .content-wrapper {
    padding-top: 5rem;
  }
</style>
